/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StruttureResDto } from '../../models/strutture-res-dto';

export interface StruttureControllerGetOneStrutturaById$Params {
  id: number;
}

export function struttureControllerGetOneStrutturaById(
  http: HttpClient,
  rootUrl: string,
  params: StruttureControllerGetOneStrutturaById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<StruttureResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    struttureControllerGetOneStrutturaById.PATH,
    'get',
  );
  if (params) {
    rb.path('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StruttureResDto>;
      }),
    );
}

struttureControllerGetOneStrutturaById.PATH = '/admin/strutture/id/{id}';
